module.exports = __webpack_public_path__ + "static/media/email-verification-successful.8926ce76.svg";